export default "__VITE_ASSET__2jIIFlGv__"